import React from 'react'
import About from './about'
import DeanMessage from './deanMessage'
import { DecodeHtml } from '../../utils/decodeHtml'

const AboutSection = ({ college }) => {
  return (
    <div className='flex flex-col gap-8'>
      <About college={college} />
      <DeanMessage college={college} />
      <div className='flex flex-col gap-5 p-4 md:px-10'>
        <h1 className='text-3xl font-bold '>About {college?.title}</h1>
        {DecodeHtml({ html: college?.aboutCollege?.markup })}
      </div>
      
    </div>
  )
}

export default AboutSection
